if (!customElements.get('deployer-card-variant-media')) {
  customElements.define(
    'deployer-card-variant-media',
    class DeployerCardVariantMedia extends HTMLElement {
      constructor() {
        super();

        this.card = this.closest('.deployer-card') || this.closest('jolly-product-card');
        this.currentVariant = null;
        this.image = this.querySelector('img');
        this.sizesAttribute = this.image.sizes;
        this.classAttribute = this.image.className;
      }

      connectedCallback() {
        this.card.addEventListener('deployer-product-card-variant:change', this.onVariantChanged.bind(this));
      }

      disconnectedCallback() {
        this.card.removeEventListener('deployer-product-card-variant:change', this.onVariantChanged.bind(this));
      }

      get widths() {
        return this.getAttribute('widths')
          .split(',')
          .map((width) => parseInt(width));
      }

      onVariantChanged(event) {
        this.currentVariant = event.detail.variant;
        this.updateImage();
      }

      updateImage() {
        if (!this.currentVariant['featured_media']) {
          return;
        }

        var newImage = this.createMediaImg(this.currentVariant['featured_media'], this.widths, { class: this.classAttribute, sizes: this.sizesAttribute });

        this.replaceChildren(newImage);
      }

      createMediaImg(media, widths = [], properties = {}) {
        const image = new Image(media['preview_image']['width'], media['preview_image']['height']);
        let featuredMediaSrc = media['preview_image']['src'];
        if (!featuredMediaSrc.startsWith('http')) featuredMediaSrc = 'https://' + featuredMediaSrc;
        const featuredMediaUrl = new URL(featuredMediaSrc);

        for (const propertyKey in properties) {
          image.setAttribute(propertyKey, properties[propertyKey]);
        }

        image.alt = media['alt'];
        image.src = featuredMediaUrl.href;
        image.srcset = this.generateSrcset(media['preview_image'], widths);

        return image;
      }

      generateSrcset(imageObject, widths = []) {
        let imageSrc = imageObject['src'];
        if (!imageSrc.startsWith('http')) imageSrc = 'https://' + imageSrc;
        const imageUrl = new URL(imageSrc);

        return widths
          .filter((width) => width <= imageObject['width'])
          .map((width) => {
            imageUrl.searchParams.set('width', width.toString());
            return `${imageUrl.href} ${width}w`;
          })
          .join(', ');
      }
    }
  );
}

if (!customElements.get('deployer-card-price-list')) {
  customElements.define(
    'deployer-card-price-list',
    class DeployerCardPriceList extends HTMLElement {
      constructor() {
        super();

        this.card = this.closest('.deployer-card') || this.closest('jolly-product-card');
        this.currentVariant = null;
        this.regularPrice = this.querySelector('.deployer-card-price--regular-price');
        this.compareAtPrice = this.querySelector('.deployer-card-price--compare-at-price');
        this.sellingPlanPrice = this.dataset.sellingPlanPrice;
      }

      connectedCallback() {
        this.card.addEventListener('deployer-product-card-variant:change', this.onVariantChanged.bind(this));
      }

      disconnectedCallback() {
        this.card.removeEventListener('deployer-product-card-variant:change', this.onVariantChanged.bind(this));
      }

      onVariantChanged(event) {
        this.currentVariant = event.detail.variant;
        this.updatePrices();
      }

      updatePrices() {
        this.regularPrice.textContent = this.formatPrice(this.currentVariant.price, 1, 0);

        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          if (this.compareAtPrice) this.compareAtPrice.textContent = this.formatPrice(this.currentVariant.compare_at_price, 1, 0);
        } else {
            if (this.compareAtPrice) this.compareAtPrice.textContent = '';
        }
      }

      updateSubscriptionPrices(enabledSubscription) {
        if (enabledSubscription) {
          this.regularPrice.textContent = this.formatPrice(this.sellingPlanPrice, 1, 0);
        } else {
          this.regularPrice.textContent = this.formatPrice(this.dataset.price, 1, 0);
        }
      }

      formatPrice(cents, quantity, discountPercents = 0) {
        const unitPrice = cents / quantity;

        const unitPriceReduced = (unitPrice * (1 - discountPercents / 100)).toFixed(2);

        let finalPrice = Math.round(((unitPriceReduced * quantity) / 100) * 10) / 10;
        // End of Selection
        const finalPriceHtml = document.body.dataset.currency + finalPrice.toFixed(2).replace(".", ",");

        return finalPriceHtml;
      }
    }
  );
}

if (!customElements.get('deployer-card-variant-picker')) {
  customElements.define(
    'deployer-card-variant-picker',
    class DeployerCardVariantPicker extends HTMLElement {
      constructor() {
        super();

        this.card = this.closest('.deployer-card') || this.closest('jolly-product-card');
        this.selects = this.querySelectorAll('select');
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.optionsNames = this.querySelectorAll('[data-selected-value]');
        this.options = [];
        this.variantsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.currentVariant = this.variantsData[0];
      }

      connectedCallback() {
        this.updateOptions();
        this.updateVariantStatuses();

        this.inputs.forEach((input) => {
          input.addEventListener('change', this.onVariantChanged.bind(this));
        });

        this.selects.forEach((select) => {
          select.addEventListener('change', this.onVariantChanged.bind(this));
        });
      }

      disconnectedCallback() {
        this.inputs.forEach((input) => {
          input.removeEventListener('change', this.onVariantChanged.bind(this));
        });

        this.selects.forEach((select) => {
          select.removeEventListener('change', this.onVariantChanged.bind(this));
        });
      }

      get VariantsData() {
        this.variantsData = this.variantsData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantsData;
      }

      onVariantChanged(event) {
        this.updateOptions();
        this.updateOptionsNames();
        this.updateCurrentVariant();
        this.updateVariantStatuses();
        this.dispatchVariantChangeEvent();
      }

      updateOptions() {
        this.options = [];
        this.options.push(
          ...Array.from(this.querySelectorAll('input[type="radio"]:checked'), (element) => {
            if (element.tagName === 'INPUT') {
              return element.value;
            }
          })
        );
        this.options.push(
          ...Array.from(this.querySelectorAll('select'), (element) => {
            if (element.tagName === 'SELECT') {
              return element.value;
            }
          })
        );
      }

      updateOptionsNames() {
        this.optionsNames.forEach((optionName, index) => {
          optionName.innerText = this.options[index];
        });
      }

      updateCurrentVariant() {
        if (this.classList.contains('deployer-card-variant-picker--dropdown')) {
          this.currentVariant = this.variantsData.find((variant) => variant.id == this.options[0]);
        } else {
          this.currentVariant = this.variantsData.find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          });
        }
      }

      updateVariantStatuses() {
        const selectedOptions = this.querySelectorAll(':checked');
        const inputWrappers = [...this.querySelectorAll('fieldset')];
        let selectedOptionOneVariants = null;
        let selectedOptionTwoVariants = null;
        let selectedOptionThreeVariants = null;
        if (selectedOptions[0]) {
          selectedOptionOneVariants = this.variantsData.filter((variant) => selectedOptions[0].value === variant.option1);
        }
        if (selectedOptions[1]) {
          selectedOptionTwoVariants = this.variantsData.filter((variant) => selectedOptions[1].value === variant.option2);
        }
        if (selectedOptions[2]) {
          selectedOptionThreeVariants = this.variantsData.filter((variant) => selectedOptions[2].value === variant.option3);
        }
        inputWrappers.forEach((option, index) => {
          if (selectedOptions.length <= 1) return;
          if (index === 0) {
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index + 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionTwoVariants.filter((variant) => variant.available && variant[`option${index + 2}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
          } else {
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
          }
        });
      }

      setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
          const value = element.getAttribute('value');
          const availableElement = availableValuesList.includes(value);

          availableElement ? element.classList.remove('disabled') : element.classList.add('disabled');
        });
      }

      dispatchVariantChangeEvent() {
        this.card.dispatchEvent(
          new CustomEvent('deployer-product-card-variant:change', {
            bubbles: true,
            detail: {
              variant: this.currentVariant,
            },
          })
        );
      }
    }
  );
}

if (!customElements.get('deployer-card-product-form')) {
  customElements.define(
    'deployer-card-product-form',
    class DeployerCardProductForm extends HTMLElement {
      constructor() {
        super();

        this.card = this.closest('.deployer-card') || this.closest('jolly-product-card');
        this.currentVariant = null;
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('#mainText');
        this.enableSellingPlan = this.querySelector('[js-enable-selling-plan]');
      }

      connectedCallback() {
        this.card.addEventListener('deployer-product-card-variant:change', this.onVariantChanged.bind(this));
        this.enableSellingPlan?.addEventListener('change', this.onEnableSellingPlanTriggered.bind(this));
      }

      disconnectedCallback() {
        this.card.removeEventListener('deployer-product-card-variant:change', this.onVariantChanged.bind(this));
        this.enableSellingPlan?.removeEventListener('change', this.onEnableSellingPlanTriggered.bind(this));
      }

      get variantId() {
        return this.querySelector('[name="id"]').value;
      }

      set variantId(value) {
        this.querySelector('[name="id"]').value = value;
      }

      onVariantChanged(event) {
        this.currentVariant = event.detail.variant;
        this.updateCurrentVariantId();
        this.updateButtonStatuses();
      }

      updateCurrentVariantId() {
        this.variantId = this.currentVariant.id;
      }

      updateButtonStatuses() {
        let availableText = this.submitButton.dataset.availableText;
        let soldOutText = this.submitButton.dataset.soldOutText;

        this.submitButton.disabled = !this.currentVariant.available;
        if (availableText !== undefined && soldOutText !== undefined) {
          this.submitButtonText.textContent = this.currentVariant.available ? availableText : soldOutText;
        }
      }

      onEnableSellingPlanTriggered(event) {
        this.updateSubscriptionPrices();
      }

      updateSubscriptionPrices() {
        const cardPriceList = this.card.querySelector('deployer-card-price-list');
        if (cardPriceList) {
          cardPriceList.updateSubscriptionPrices(this.enableSellingPlan.checked);
        }
      }
    }
  );
}
